


<template>
<div class="locationpicker_container">
    <div class="locationpicker" v-bind:style="{width: mapWidth, height: mapHeight}">
        <div class="mapcontainer">
            <heremap ref="map" :lat="latitude" :lng="longitude" :width="mapWidth" :height="mapHeight" :showPositionMarker="showPositionMarker" :interactive="interactive" :picker="true" @locationSelected="locationSelected" @searchResultsUpdated="searchResultsUpdated" @markerReverseGeocoded="markerReverseGeocoded" />
        </div>
        <div class="searchfield" v-if = interactive>
            <input v-bind:style="{width: searchfieldWidth}" v-on:keyup.enter="updateSearchResults" type="text" v-model="searchQuery" :placeholder="$t('roster.comp.searchAddress')"/>
            <div class="button green" @click="updateSearchResults()">
                <div class="label">
                    {{ $t('roster.comp.search') }}
                </div>
            </div>
        </div>
    </div>
    <div class="selected_location" v-if="selectedLocation != null" v-bind:style="{width: mapWidth}">
        <strong>{{ $t('roster.comp.selectedAddress') + ': '}}</strong>{{selectedLocationLabel}}<br/>
        <strong>GPS (Latitude/Longitude): </strong>{{selectedLocation.lat + ' / ' + selectedLocation.lng}}<br/>
    </div>
    </div>
</template>

<script>

    import heremap from "../maps/heremap.vue"
    
    export default {
        name: "mdlocationpicker",
        data() {
            return {
                map: {},
                platform: {},
                
                searchQuery: "",
                searchResults: [],
                selectedLocation: null,
                selectedLocationLabel: ""
            }
        },
        props: {
            lat: Number,
            lng: Number,
            width: Number,
            height: Number,
            interactive: Boolean,
            targetEntry: Object,
            showPositionMarker: {
                type: Boolean,
                default: () => (false)
            }
        },
        components: { heremap },
        created() {
        },
        computed: {
            
            mapWidth(){
                if(this.width == null) return "500px";
                return (this.width - 2) + 'px';
            },
            mapHeight(){
                if(this.height == null) return "300px";
                return this.height + 'px';
            },
            searchfieldWidth(){
                let mapWidth = 500;
                if(this.width != null) mapWidth = this.width;
                let fieldWidth = Number(mapWidth) - 32 - 57;
                return fieldWidth + 'px';
            },
            latitude(){
                if(this.lat == null){
                    return 48.2171528;
                }
                return this.lat;
            },
            longitude(){
                if(this.lng == null){
                    return 16.3914293;
                }
                return this.lng;
            }
        },
        watch: {
            selectedLocation(newVal, oldVal){
                this.$emit('locationSelected', this.selectedLocation);
                if(this.targetEntry != null) this.targetEntry.value = this.selectedLocation;
            }
        },
        mounted() {
            if(this.showPositionMarker){
                this.selectedLocation = {lat: this.latitude, lng: this.longitude};
                this.reverseGeocodeMarkerPosition({lat: this.latitude, lng: this.longitude});
            }
            console.log(this.interactive)
        },
        methods: {
            locationSelected(position){
                if(this.interactive){
                    this.selectedLocation = position;
                    this.searchResults = [];
                }
                
            },
            updateSearchResults(){
                let map = this.$refs['map'];
                map.geocode(this.searchQuery);
            },
            searchResultsUpdated(results){
                this.searchResults = results;
                    // move to the first search result and show info bubble
                    let map = this.$refs['map'];
                    let location = results[0];
                    this.searchResults = [];
                    map.setCenter(location.position, null, true);
                    this.selectedLocation = location.position;
                    this.selectedLocationLabel = location.address.label;
                    this.searchQuery = location.address.label;
            },
            reverseGeocodeMarkerPosition(position){
                let map = this.$refs['map'];
                map.reverseGeocode(position);
            },
            markerReverseGeocoded(infoText){
                this.selectedLocationLabel = infoText;
            }
        }
    }
</script>

<style scoped>

.locationpicker{
    position: relative;
    text-align: left;
}

.locationpicker_container{
    border: solid 0.5px var(--contrast-6);
}

.searchfield{
    position: absolute;
    left: 16px;
    top: 16px;
    height: 24px;
    overflow: hidden;
    background-color: var(--bg);
    box-shadow: 0px 10px 13px -7px #000000, 5px 5px 15px 5px rgba(0,0,0,0);
}

.selected_location{
    font-family: DistrictProBook;
    font-size: 13px;
    position:relative;
    text-align: left;
    /* border-left: solid 0.5px var(--contrast-6);
    border-right: solid 0.5px var(--contrast-6);
    border-bottom: solid 0.5px var(--contrast-6); */
    background-color: var(--bg);
    color: var(--col-label-default);
    padding: 4px 4px 4px 4px;
}

.mapcontainer{
    position: absolute;
}
.searchfield .button{
    height: 25px;
    margin-left: 0px;
    background-color: var(--md);
}

.searchfield input {
    border-radius: 0px;
    height: 25px;
    box-shadow: none;
    background-color: var(--bg);
}
</style>